var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { professionalStatusEntityName, } from '../../../../backend/config/classifiers/entities/defineProfessionalStatusClassifier';
import { occupationGroupEntityName, professionalStatusTypeLabel, professionalStatusTypes, } from '../../../../backend/config/shared';
import { getClassifierIdsByNamesAsync } from '../../../../ui/features/classifiers-admin-pages/utils/getClassifierIdsByNameAsync';
import { getClassifierNamesAsync } from '../../../../ui/features/classifiers-admin-pages/utils/getClassifierNamesAsync';
import { ClassifierAdminPage, ClassifierValue, SlideoutFields, } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    const typeLabel = professionalStatusTypeLabel[props.response.data.type];
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Type', value: typeLabel !== null && typeLabel !== void 0 ? typeLabel : React.createElement("em", null, "(not set)") },
            {
                label: 'Occupation Groups',
                value: props.response.data.occupationGroupIds.reduce((groupIdNodes, groupId) => {
                    if (groupIdNodes.length <= 0) {
                        return [React.createElement(ClassifierValue, { key: groupId, entity: 'occupationGroup', id: groupId })];
                    }
                    return [...groupIdNodes, ',\t', React.createElement(ClassifierValue, { key: groupId, entity: 'occupationGroup', id: groupId })];
                }, []),
            },
        ] }));
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.select',
            key: 'type',
            label: 'Type',
            validate: {
                required: true,
            },
            values: professionalStatusTypes.map((type) => ({
                value: type,
                label: professionalStatusTypeLabel[type],
            })),
        },
        {
            type: 'form.multiSelect',
            key: 'occupationGroupIds',
            label: 'Occupation Group',
            validate: {
                required: true,
            },
            valueProvider: {
                type: `classifier.${occupationGroupEntityName}`,
            },
        },
        { type: 'form.number', key: 'displayOrder', label: 'Display Order', integer: true },
    ],
};
const csvFileHeader = ['ID', 'Name', 'Status', 'Type', 'Occupation Groups', 'Display Order'];
function mapCsvRowToData(row) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
        const status = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
        const typeLabel = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim();
        const occupationGroupNames = ((_e = row.data[4]) !== null && _e !== void 0 ? _e : '').trim();
        const displayOrder = ((_f = row.data[5]) !== null && _f !== void 0 ? _f : '').trim();
        if (name.length === 0) {
            row.errors.push('Name is required');
        }
        if (typeLabel.length === 0) {
            row.errors.push('Type is required');
        }
        if (status.length === 0) {
            row.errors.push('Status is required');
        }
        const type = (_g = Object.entries(professionalStatusTypeLabel).find(([, label]) => label === typeLabel)) === null || _g === void 0 ? void 0 : _g[0];
        if (!type) {
            row.errors.push(`Type can't be resolved`);
        }
        const occupationGroupIds = (_h = (yield getClassifierIdsByNamesAsync(occupationGroupEntityName, occupationGroupNames.split(';'), row.errors, (groupName) => `Occupation Group not found: ${groupName}`))) !== null && _h !== void 0 ? _h : [];
        switch (status) {
            case 'active':
            case 'deprecated':
            case 'retired':
                break;
            default:
                row.errors.push('Invalid status, expected one of: active, deprecated, retired');
        }
        let displayOrderNumber;
        if (displayOrder) {
            displayOrderNumber = parseFloat(displayOrder);
            if (!isFinite(displayOrderNumber)) {
                row.errors.push('Invalid display number, expected a number');
                displayOrderNumber = undefined;
            }
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name: name,
                    status: status,
                    type: type,
                    occupationGroupIds: occupationGroupIds,
                    displayOrder: displayOrderNumber,
                },
            };
        }
        return Promise.resolve(row);
    });
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const typeLabel = professionalStatusTypeLabel[response.data.type];
        const occupationGroupTitles = yield getClassifierNamesAsync(occupationGroupEntityName, response.data.occupationGroupIds);
        return [
            response.id,
            response.data.name,
            response.data.status,
            typeLabel,
            occupationGroupTitles.join(';'),
            response.data.displayOrder != null ? response.data.displayOrder.toString() : '',
        ];
    });
}
export const ProfessionalStatusAdminPage = () => {
    return (React.createElement(ClassifierAdminPage, { entity: professionalStatusEntityName, title: 'Professional Status', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: formConfig, csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
